import { AxiosError } from "axios";
import api from "@/app/axios/axiosInstance";

export interface JabatanServiceResponse {
  success: boolean;
  status: number;
  data?: string[];
  message?: string;
}

export const jabatanMasterServices = {
  getAll: async (): Promise<JabatanServiceResponse> => {
  try {
    const response = await api.get<{
      data: { ID: number; Nama: string }[];
    }>("/jabatan");

    return {
      success: true,
      status: response.status,
      data: response.data.data.map((item) => item.Nama),
    };
  } catch (error) {
    const axiosError = error as AxiosError<{ error?: string; message?: string }>;
    return {
      success: false,
      status: axiosError.response?.status ?? 500,
      message:
        axiosError.response?.data?.error ??
        axiosError.response?.data?.message ??
        "Gagal mengambil data jabatan",
    };
  }
},
};